import { api as wiredApi } from './index';

/** The ways to pay whose phone is prompted: EcoCash, and Paynow's EcoCash or OneMoney. */
const PHONE_METHODS = ['mobile', 'paynow'];

/**
 * Paying for a delivery on InGo's API (InGo ADR 0047; the payments plan S2,
 * S4, S5). The server decides everything: which ways to pay are on, what the
 * fee is, what is charged, and whether it is paid. The app only shows it.
 *
 * Built from its collaborators so a test can hand it fakes; `payments` is the
 * wired copy.
 */
export function createPayments({ api }) {
  return {
    /**
     * `GET public/payment-methods`: the ways to pay the office has on, in
     * order, each `{key, gateway, fee}`. Cash alone when the server cannot be
     * asked: a client can always book the way they always could.
     */
    async methods() {
      try {
        const { data } = await api.get('/public/payment-methods');
        const methods = Array.isArray(data?.methods) ? data.methods.filter((m) => typeof m?.key === 'string') : [];

        return methods.length > 0 ? methods : [{ key: 'cash', gateway: null, fee: null }];
      } catch {
        return [{ key: 'cash', gateway: null, fee: null }];
      }
    },

    /**
     * `POST customer/me/deliveries/{id}/payments`: start paying this way.
     * Answers `{delivery, payment}`; `payment` is null when cash booked it.
     * EcoCash and Paynow prompt the number that pays (InGo ADR 0048, 0050):
     * `phone`, sent only for those two. A card answers `payment.stripe`, the
     * publishable key and client secret its screen confirms with.
     */
    async start(deliveryId, method, phone = null) {
      const body = PHONE_METHODS.includes(method) && phone ? { method, phone } : { method };
      const { data } = await api.post(`/customer/me/deliveries/${deliveryId}/payments`, body);

      return data;
    },

    /** `GET …/payments/latest`: the latest attempt and where the delivery stands. */
    async latest(deliveryId) {
      const { data } = await api.get(`/customer/me/deliveries/${deliveryId}/payments/latest`);

      return data;
    },
  };
}

export const payments = createPayments({ api: wiredApi });
